import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CodigoProductoEnum } from 'src/app/global/enums/codigo-producto.enum';
import { ACTIONS, DialogResult } from 'src/app/global/models/dialog/dialog-data';
import { LocalStorageService } from 'src/app/global/services/localstorage.service';
import { SessionService } from 'src/app/global/services/session.service';
import { TagManagerService } from 'src/app/global/services/tag-manager.service';
import { Product } from 'src/app/view-model/components/shopping-cart/product';
import { CarroComprasService } from 'src/app/view-model/services/carro-compras.service';
import { DialogService } from 'src/app/view-model/services/dialog.service';
import { MarketplaceRedirectService } from 'src/app/view-model/services/marketplace-redirect-vm.service';
import { StepperServiceVM } from 'src/app/view-model/services/stepper-vm.service';
@Component({
  selector: 'app-carro-compra',
  templateUrl: './carro-compra.component.html',
  styleUrls: ['./carro-compra.component.scss']
})
export class CarroCompraComponent implements OnInit {

  get carroCompraVacio() {
    return this.carroComprasService.carroCompraVacio;
  }
  set carroCompraVacio(value: boolean) { this.carroComprasService.carroCompraVacio = value; }

  constructor(
    private router: Router,
    public carroComprasService: CarroComprasService,
    private marketplaceRedirectService: MarketplaceRedirectService,
    private stepperServiceVM: StepperServiceVM,
    protected dialogService: DialogService,
    private tagM: TagManagerService,
    private localStorageService: LocalStorageService,
    private sessionService: SessionService
  ) { }

  @Input() formatoExito: boolean;
  @Input() carroOnExito: boolean;
  @Input() visibleCarro: boolean; // recibe una propiedad desde fuera
  @Input() discountBox: boolean = false;

  isClicked = false;
  isClickedIntegracion = false;
  retoma = false;
  isWix:boolean = false;

  carroCompraSeleccionBtn: boolean;
  carroCompraProductos: boolean;
  fixcarroFelicita: boolean;
  product: Product;
  screenSize: number;

  // CARRO_COMPRA POS
  tituloProductos = 'Pos Fijo';
  cantidadProductos = 'Estás solicitando 2 productos';
  tipodeVentaProducto = 'presencial';
  equiposFijos = false;
  textoBoton = 'Solicitar';
  tipoProducto = 'tipoPos';
  modificarTitulo = false;
  esPaso3 = false;

  rubroSeleccionado: any;

  @Input() products: Product[] = [];

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenSize = window.innerWidth;
  }

  ngOnInit() {
    this.carroComprasService.retoma$.subscribe(resp => {
      this.retoma = resp;
    });
    this.screenSize = window.innerWidth;
    this.carroCompraSeleccionBtn = false;
    if (this.carroCompraSeleccionBtn) {
      this.textoBoton = 'Solicitar';
    } else {
      this.textoBoton = 'Modificar Producto';
    }
    if (this.products.length === 0) {
      this.carroCompraVacio = false;
    }
    this.carroCompraProductos = true;

    this.carroComprasService.changePaso$.subscribe(paso => {
      if (paso === 'P_3' || paso === 'RESUMEN') {
        this.esPaso3 = true;
        if (paso === 'RESUMEN') {
          this.modificarTitulo = true;
        } else {
          this.modificarTitulo = false;
        }
      } else {
        this.esPaso3 = false;
        this.modificarTitulo = false;
      }

      /*Comprobacion Rubro Riesgoso*/
      this.sessionService.getRubroSeleccionado();
    });
    this.checkIfWix();
    this.checkSize();
    
    this.sessionService.rubroSeleccionado$.subscribe(data => {
      this.rubroSeleccionado = data;
    });
  }

  /**
   * Identifica si el carrito tiene producto Wix dentro (inicialmente para ocultar caja de descuento)
   */
  private checkIfWix() {
    this.isWix = this.products.some(product => product.codigoProducto == CodigoProductoEnum.CREACION_SITIO_ALIANZA_WIX);
  }
  /** Deshabilitacion de caja de descuento para WIX */

  private checkSize() {
    if (this.screenSize <= 1200) {
      this.carroComprasService.hide();
    } else {
      this.carroComprasService.show();
    }
  }

  modificarProductos() {
    this.product = this.products[0];

    if (this.screenSize < 960) {
      this.carroComprasService.hide();
    }
    const dialogRef = this.dialogService.openChangeProductDialog(this.product);
    dialogRef.afterClosed().subscribe((dialogResult: DialogResult) => {
      if (dialogResult && dialogResult.action === ACTIONS.OK) {
        const step = this.stepperServiceVM.currentStep;
        if (step === 0) {
          this.marketplaceRedirectService.redirectWithProducts();
          this.tagM.logAgregarProducto('Modificar Producto');
        } else if (step === 1) {
          this.marketplaceRedirectService.redirectWithProductsAndToken();
          this.tagM.logAgregarProducto('Modificar Producto');
        }
      } else {
        if (this.screenSize < 960) {
          this.carroComprasService.show();
        }
      }
    });
  }

  agregarProductos() {
    this.tagM.logAgregarProducto('Agregar Producto');
    this.marketplaceRedirectService.redirect();
  }

  rotarBoton() {
    this.isClicked = !this.isClicked;
  }

  rotarBotonIntegracio() {
    this.isClickedIntegracion = !this.isClickedIntegracion;
  }

  navigateToLogin() {
    this.router.navigateByUrl('/productogenerado');
  }

  public abrirCobroAdicionalmodal(): void {
    console.log("entro openCobroAdicionalDialog ");
    const dialogRef = this.dialogService.openValoresMCCDialog();
    dialogRef.afterClosed().subscribe(resp => {
      console.log("Modal cerrado");
    });
  }
}
